import { render, staticRenderFns } from "./ProductVariantContentCreateItem.vue?vue&type=template&id=77cadd44&scoped=true&"
import script from "./ProductVariantContentCreateItem.vue?vue&type=script&lang=js&"
export * from "./ProductVariantContentCreateItem.vue?vue&type=script&lang=js&"
import style0 from "./ProductVariantContentCreateItem.vue?vue&type=style&index=0&id=77cadd44&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77cadd44",
  null
  
)

export default component.exports